// extracted by mini-css-extract-plugin
export default {"root":"CustomDragPreview_root__MdZfz","icon":"CustomDragPreview_icon__MGugn","label":"CustomDragPreview_label__zBNpE"};